import { useTranslation } from 'react-i18next'

import { Button } from 'components/Button/Button'
import { IconButton } from 'components/IconButton/IconButton'
import UserInfo from 'components/UI/UserInfo/UserInfo'
import { useModalContext } from 'context/modalContext'
import { AllIcons } from 'helpers/allIcons'
import { type User } from 'types/types'

import './FriendRequestMessageModal.scss'

interface FriendRequestMessageModalProps {
    user: User
    friendReqAccept?: () => void
    friendReqDeny?: () => void
}

const FriendRequestMessageModal = (props: FriendRequestMessageModalProps) => {
    const modalContext = useModalContext()
    const { t } = useTranslation()

    const {
        user: { message },
        friendReqAccept,
        friendReqDeny
    } = props

    const handleAction = async (action?: () => void) => {
        action && action()
        modalContext.clearModal()
    }

    return (
        <div className='friendReqMessageModal'>
            <UserInfo user={props.user} avatar={props.user.avatar.url} />
            <div className='friendReqMessageModal__message'>{message}</div>
            <div className='buttons'>
                <IconButton
                    type='white'
                    clickFn={async () => {
                        await handleAction(friendReqDeny)
                    }}
                    icon={AllIcons.close}
                    customClass='button button__deny'
                />
                <Button
                    text={t('accept')}
                    color='blue'
                    font='mont-14-normal'
                    width='fit'
                    padding='3'
                    height='3'
                    customClass='button button__accept'
                    clickFn={async () => {
                        await handleAction(friendReqAccept)
                    }}
                />
            </div>
        </div>
    )
}

export default FriendRequestMessageModal
